export default document.querySelector<HTMLMetaElement>('meta[name="application-version"]')?.content;
